import { useState, useEffect } from 'react';

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img 
              src="https://hurley-associates.com/web/images/logo21t.gif" 
              alt="Frank T. Hurley Associates, Inc." 
              className="h-16 w-auto"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Services
            </button>
            <button onClick={() => scrollToSection('listings')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Listings
            </button>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Contact
            </button>
            <a href="tel:727-367-1949" className="flex items-center space-x-2 bg-teal-600 text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              <span>727-367-1949</span>
            </a>
          </div>

          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl w-6 h-6 flex items-center justify-center`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              Services
            </button>
            <button onClick={() => scrollToSection('listings')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              Listings
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              Contact
            </button>
            <a href="tel:727-367-1949" className="flex items-center justify-center space-x-2 bg-teal-600 text-white px-5 py-3 rounded-full text-sm font-semibold hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              <span>727-367-1949</span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}